import { useState, useRef, useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import Select from 'react-select'

import { itemsFetchData } from '../../redux/items'
import DropdownToggle from './DropdownToggle'
import { parseSubjectsFromUrl } from '../../SearchUtils'
import { createDropdown, whenBootstrapReady } from '../../../helpers/bootstrap'

function SelectFilter({ name, title, type, fetchData, options }) {
  const { currentFilters } = useSelector((state) => state.items)

  const [selectedOption, setSelectedOption] = useState(null)

  const dropdownRef = useRef(null)

  useEffect(() => {
    const dropdownToggleEl = document.getElementById(`dropdown-filter-${name}`)
    return whenBootstrapReady(() => {
      dropdownRef.current = createDropdown(dropdownToggleEl)
    })
  }, [])

  const handleSubmit = () => {
    const newFilters = {
      popstate: 0,
      subjects: parseSubjectsFromUrl(),
      ...currentFilters,
    }

    if (selectedOption && selectedOption.value) {
      newFilters[name] = [...(newFilters[name] || [])]

      // eslint-disable-next-line default-case
      switch (type) {
        case 'array':
          if (!newFilters[name].includes(selectedOption.value)) {
            newFilters[name].push(selectedOption.value)
          }
          break
      }

      setSelectedOption(null)

      delete newFilters.page

      dropdownRef.current?.toggle()

      fetchData(newFilters)
    }
  }

  return (
    <div className="dropdown d-block">
      <DropdownToggle name={name} title={title} />
      <div
        className="dropdown-menu w-100 p-2"
        aria-labelledby={`dropdown-filter-${name}`}
        id={`dropdown-menu-filter-${name}`}
      >
        <div>
          <div className="mb-3">
            <label>{title}</label>
            <Select
              inputProps={{ type: 'text' }}
              onChange={setSelectedOption}
              value={selectedOption}
              options={options}
              placeholder={`${I18n.t('select')}...`}
            />
          </div>
          <button
            className="btn btn-primary d-block mt-2 w-100"
            type="button"
            onClick={handleSubmit}
            disabled={!selectedOption}
          >
            {I18n.t('submit')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default connect(
  (state) => ({
    currentFilters: state.items.currentFilters,
  }),
  (dispatch) => ({
    fetchData: (filters) => dispatch(itemsFetchData({ filters })),
  })
)(SelectFilter)
